import { createAsyncThunk } from '@reduxjs/toolkit';
import onlineUsersApi from '../../../api/onlineUsersApi';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'onlineUsers';

export const GetOnlineUsers = createAsyncThunk<any, void>(`${REDUCER_NAME}/getOnlineUsers`, async (_, thunkAPI) => {
  const res = await onlineUsersApi.get();

  if (res?.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});
